module.exports = __webpack_public_path__ + "baf6137a797f267b6abe88c9b34a9e99.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/questions_old.png
// module id = 1552
// module chunks = 0